module.exports = __webpack_public_path__ + "static/media/oncology-icon.b034e3fc.svg";